import React from "react";
import CustomerGroupList from "./CustomerGroupList";

const CustomerGroup = () => (
  <div className="container-fluid py-2">
    <CustomerGroupList />
  </div>
);

export default CustomerGroup;